export let defaultme = null;

/**
 * Runtime type representing the detected JavaScript runtime environment
 */
export type TRuntimeType = 'node' | 'deno' | 'bun' | 'browser';

/**
 * Runtime target for module loading - can be a specific runtime or 'server' for all server-side runtimes
 */
export type TRuntimeTarget = TRuntimeType | 'server';

declare global {
  namespace NodeJS {
    interface Global {
      window: any;
      navigator: any;
    }
  }
}
